import axios from "axios";
import { isDemoOn, maskCliente, maskFornecedor, maskMotorista, maskPlaca, maskCNPJ, maskEmpresa } from "@/lib/demoMask";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("serenata_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Mapa dos campos mascarados quando o Modo Demo está ativo.
// A máscara é APLICADA APENAS NA RESPOSTA — banco intocado.
const DEMO_FIELD_MASKERS = {
  cliente: maskCliente,
  cliente_nome: maskCliente,
  cliente_dono: maskCliente,
  nome_cliente: maskCliente,
  fornecedor: maskFornecedor,
  nome_fornecedor: maskFornecedor,
  motorista: maskMotorista,
  placa: maskPlaca,
  cnpj: maskCNPJ,
  cnpj_cpf: maskCNPJ,
  cliente_dono_cnpj: maskCNPJ,
  nome_fantasia: (v) => maskEmpresa(v, "fantasia"),
  razao_social: (v) => maskEmpresa(v, "razao"),
  destino: (v) => "CIDADE DEMO",
  cidade: (v) => "São Paulo",
  logradouro: (v) => "Rua Exemplo",
  bairro: (v) => "Bairro Central",
  cep: (v) => "00.000-000",
  ie: (v) => "000.000.000",
  telefone: (v) => "(11) 3000-0000",
  email: (v) => v && v.includes("@") ? "contato@empresa-demo.com.br" : v,
};

// Chaves cujo VALUE é um objeto de snapshot de cliente — mascara todos os campos sensíveis dentro
const DEMO_SNAPSHOT_KEYS = new Set(["cliente_snapshot", "fornecedor_snapshot"]);

function walkAndMask(node) {
  if (node == null) return node;
  if (Array.isArray(node)) {
    for (let i = 0; i < node.length; i++) walkAndMask(node[i]);
    return node;
  }
  if (typeof node !== "object") return node;
  for (const k of Object.keys(node)) {
    const v = node[k];
    if (DEMO_SNAPSHOT_KEYS.has(k) && v && typeof v === "object") {
      // Dentro de snapshot: mascara `nome` também
      if (typeof v.nome === "string") v.nome = maskCliente(v.nome);
      walkAndMask(v);
    } else if (v && typeof v === "object") {
      walkAndMask(v);
    } else if (typeof v === "string" && DEMO_FIELD_MASKERS[k]) {
      node[k] = DEMO_FIELD_MASKERS[k](v);
    }
  }
  return node;
}

api.interceptors.response.use(
  (r) => {
    if (isDemoOn() && r && r.data) walkAndMask(r.data);
    return r;
  },
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("serenata_token");
        localStorage.removeItem("serenata_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" • ");
  return String(d);
}

/** Converte ISO (YYYY-MM-DD ou YYYY-MM-DDTHH:MM...) para DD/MM/AAAA. */
export function fmtDate(iso) {
  if (!iso) return "—";
  const s = String(iso);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  try {
    const d = new Date(iso);
    if (!isNaN(d)) return d.toLocaleDateString("pt-BR");
  } catch (e) { /* ignore */ }
  return s;
}

/** Converte ISO com hora para DD/MM/AAAA HH:MM. */
export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (!isNaN(d)) return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch (e) { /* ignore */ }
  const dateOnly = fmtDate(iso);
  return dateOnly;
}
